<stages-auto-complete-search
	#autoComplete
	[placeholder]="
		hasAssignableAndNonRestrictedDependentElementSubtype(dependentElementContainer) || this.sourceAssociation()
			? targetElementCreateAllowed()
				? ('process.element.quickAssign.select.dependentElementCreatePlaceholder' | translate)
				: ('process.element.quickAssign.select.dependentElementPlaceholder' | translate)
			: ('search.autoComplete.placeholder' | translate)
	"
	[query]="getSearchQuery()"
	(submitted)="selectItemCallback($event)"
	[searchResultTemplate]="searchResultTemplate"
	[searchResultSeparatorTemplate]="searchResultSeparatorTemplate"
	[createDependendElementAllowedCallback]="isCreateAllowed"
	[dropDownClass]="'margin-reduced-h'"
	[inputIconClasses]="getInputIconClasses()"
	[maxSearchTermLength]="255"
	(cancelled)="cancel()"
	(backButtonPressed)="back()"
	[isInSubordinatedElementsMode]="showSubordinatedElementsMode()"
	[backButtonActive]="backButtonActive"
>
	<ng-template #searchResultTemplate let-item>
		<i class="ico" [ngClass]="getIconClassesAndCheckForDependentType(item)"></i>
		@if (!item.isNew) {
			@if (!item.isNew) {
				<p [ngClass]="getLabelClasses(item)" class="has-chevron-right">
					{{ item.label }}
					@if (item.isRemote) {
						<i class="ico ico-change-workspace"></i>
					}
					@if (
						item.dependentElementsContainer &&
						(restrictAssociateDependentElementTypes() === undefined ||
							restrictAssociateDependentElementTypes()!.length > 0)
					) {
						<i class="ico ico-chevron-right ico-right"></i>
					}
				</p>
			}
			@if (item.isRemote) {
				<p class="workspace-name">{{ item.workspaceName }}</p>
			}
		}
		@if (item.isNew) {
			<p
				[ngClass]="getLabelClasses(item)"
				[translate]="item.isComment ? 'search.autoComplete.createCommentOnlyAssociation' : 'search.autoComplete.create'"
				[translateParams]="{ ARG0: item.name }"
			></p>
		}
	</ng-template>

	<ng-template #searchResultSeparatorTemplate let-item>
		@if (showSeparator(item)) {
			<li class="separator">
				<h6>
					<span
						[translate]="
							isItemInLocalWorkspace(item)
								? 'search.autoComplete.assocTarget.inThisWorkspace'
								: 'search.autoComplete.assocTarget.inOtherWorkspaces'
						"
					></span>
				</h6>
			</li>
		}
	</ng-template>
</stages-auto-complete-search>
